import { Box, Button, Card, CardContent, CardHeader, FormControl, InputLabel, List, ListItem, MenuItem, Select, Stack, Typography, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isActive, useAuth } from "../../contexts/AuthContext";

const Activate = () => {
    const {user, refreshUser} = useAuth();
    const [activation, setActivation] = useState("1")
    const navigate = useNavigate();
    const handleChange = (e) => {
        e.preventDefault();
        setActivation(e.target.value);
    };
    useEffect(() => {
        //window.location.reload();
        refreshUser();
    }, [])
    return (
        <Box sx={{ paddingBottom: '80px' }}>
            {isActive() ?
                <>
                    <Card 
                        elevation={6}
                        sx={{
                            borderRadius: 4,
                            border: '1px solid',
                            borderColor: 'divider',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': {
                                boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                transform: 'translateY(-2px)',
                            },
                        }}
                    >
                        <CardHeader 
                            sx={{ textAlign: 'center', pb: 1 }}
                            title={
                                <Typography 
                                    sx={{ 
                                        fontWeight: 600,
                                        fontSize: '1.125rem',
                                        color: 'text.primary',
                                        letterSpacing: '-0.01em',
                                        textAlign: 'center',
                                        width: '100%'
                                    }} 
                                    variant="h6"
                                >
                                    Account Status
                                </Typography>
                            } 
                        />
                        <CardContent>
                            <Box display="flex" justifyContent="center" alignItems="center">
                                <Stack spacing={2} sx={{ width: '100%', maxWidth: '500px' }}>
                                    <Typography variant="body1" sx={{ textAlign: 'center', color: 'text.secondary' }}>
                                        Your account is already active, you can do self-test practice.
                                    </Typography>
                                    <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary' }}>
                                        To Enroll student(s) click here:
                                    </Typography>
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <Button 
                                            type="submit" 
                                            color="success" 
                                            variant="contained" 
                                            onClick={(e) => { e.preventDefault(); navigate("/app/enroll") }}
                                            sx={{
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    transform: 'translateY(-2px)',
                                                    boxShadow: (theme) => theme.shadows[8],
                                                },
                                            }}
                                        >
                                            Enroll Student(s)
                                        </Button>
                                    </Box>
                                </Stack>
                            </Box>
                        </CardContent>
                    </Card>
                </>
                :
                <Card 
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <CardHeader 
                        sx={{ textAlign: 'center', pb: 1 }}
                        title={
                            <Typography 
                                sx={{ 
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }} 
                                variant="h6"
                            >
                                Activation Options
                            </Typography>
                        } 
                    />
                    <CardContent>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Stack spacing={3} sx={{ width: '100%', maxWidth: '500px' }}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel>Activation Type</InputLabel>
                                    <Select
                                        value={activation}
                                        onChange={handleChange}
                                        label="Activation Type"
                                        name="activation"
                                    >
                                        <MenuItem value="1">I want to practice on my own.</MenuItem>
                                        <MenuItem value="2">I want student(s) only to practice.</MenuItem>
                                        <MenuItem value="3">I want to practice and student(s) also to practice.</MenuItem>
                                    </Select>
                                </FormControl>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <Stack spacing={2} sx={{ width: '100%' }}>
                                        {activation === "1" &&
                                            <Button 
                                                type="submit" 
                                                color="success" 
                                                variant="contained" 
                                                fullWidth
                                                onClick={(e) => { e.preventDefault(); navigate("/app/activate/"+user["id"]) }}
                                                sx={{
                                                    transition: 'all 0.2s ease-in-out',
                                                    '&:hover': {
                                                        transform: 'translateY(-2px)',
                                                        boxShadow: (theme) => theme.shadows[8],
                                                    },
                                                }}
                                            >
                                                Activate
                                            </Button>
                                        }
                                        {activation === "2" &&
                                            <Button 
                                                type="submit" 
                                                color="success" 
                                                variant="contained" 
                                                fullWidth
                                                onClick={(e) => { e.preventDefault(); navigate("/app/enroll") }}
                                                sx={{
                                                    transition: 'all 0.2s ease-in-out',
                                                    '&:hover': {
                                                        transform: 'translateY(-2px)',
                                                        boxShadow: (theme) => theme.shadows[8],
                                                    },
                                                }}
                                            >
                                                Enroll Student(s)
                                            </Button>
                                        }
                                        {activation === "3" &&
                                            <Stack spacing={3}>
                                                <Box>
                                                    <Typography variant="body2" sx={{ mb: 2, textAlign: 'center', color: 'text.secondary' }}>
                                                        First Activate your account by clicking below
                                                    </Typography>
                                                    <Button 
                                                        type="submit" 
                                                        color="success" 
                                                        variant="contained" 
                                                        fullWidth
                                                        onClick={(e) => { e.preventDefault(); navigate("/app/activate/"+user["id"]) }}
                                                        sx={{
                                                            transition: 'all 0.2s ease-in-out',
                                                            '&:hover': {
                                                                transform: 'translateY(-2px)',
                                                                boxShadow: (theme) => theme.shadows[8],
                                                            },
                                                        }}
                                                    >
                                                        Activate
                                                    </Button>
                                                </Box>
                                                <Divider />
                                                <Box>
                                                    <Typography variant="body2" sx={{ mb: 2, textAlign: 'center', color: 'text.secondary' }}>
                                                        And then enroll student(s) and activate them
                                                    </Typography>
                                                    <Button 
                                                        type="submit" 
                                                        color="success" 
                                                        variant="contained" 
                                                        fullWidth
                                                        onClick={(e) => { e.preventDefault(); navigate("/app/enroll") }}
                                                        sx={{
                                                            transition: 'all 0.2s ease-in-out',
                                                            '&:hover': {
                                                                transform: 'translateY(-2px)',
                                                                boxShadow: (theme) => theme.shadows[8],
                                                            },
                                                        }}
                                                    >
                                                        Enroll Student(s)
                                                    </Button>
                                                </Box>
                                            </Stack>
                                        }
                                    </Stack>
                                </Box>
                            </Stack>
                        </Box>
                    </CardContent>
                </Card>
            }
        </Box>
    );
};

export default Activate;